import {
  axiosDeleteRequest,
  axiosGetRequest,
  getHealthPictureRoute,
} from '../../api';
import {
  EnhancedSurveySubmission,
  EnhancedSurveySubmissionPreview,
  EnhancedSurveySubmissionResetResult,
} from './model';

const submissionsRoute = () =>
  `${getHealthPictureRoute()}/enhanced-survey/submissions`;

export const fetchEnhancedSurveySubmissionsCall = () =>
  axiosGetRequest<EnhancedSurveySubmission[]>(submissionsRoute());

export const fetchEnhancedSurveySubmissionPreviewCall = (sessionId: string) =>
  axiosGetRequest<EnhancedSurveySubmissionPreview>(
    `${submissionsRoute()}/${sessionId}`
  );

export const resetEnhancedSurveySubmissionCall = (sessionId: string) =>
  axiosDeleteRequest<string, EnhancedSurveySubmissionResetResult>(
    `${submissionsRoute()}/${sessionId}`
  );
